export interface AuthState {
    isAuthenticated: boolean | null;
    accessToken: string | null;
    user: any | null;
    actor: any | null;
    loading: boolean;
    error: string | null;
    lastAuthCheck: number | null;
}

export const initialAuthState: AuthState = {
    isAuthenticated: null,
    accessToken: null,
    user: null,
    actor: null,
    loading: false,
    error: null,
    lastAuthCheck: null
};
